import React from 'react';
import { BackgroundVideo } from './components/molecules/background_video'
import { ConfirmModal } from './components/molecules/confirm_modal'
import { Header } from './components/organisms/header'
import { FirstView } from './components/organisms/first_view'
import { SystemView } from './components/organisms/system'
import { PointSystemView } from './components/organisms/point_system'
import { AlignerView } from './components/organisms/aligner_view'
import { PointAlignerView } from './components/organisms/point_aligner'
import { ValuePropositionView } from './components/organisms/value_proposition'
import { FlowView } from './components/organisms/flow'
import { ExampleView } from './components/organisms/example'
import { OwnerView } from './components/organisms/owner_view'
import { Footer } from './components/organisms/footer'
import { MainContent } from './components/template/main_content'

function App() {
  return (
    <div className="App">
      <ConfirmModal />
      <BackgroundVideo />
      <MainContent>
        <Header />
        <FirstView />
        <SystemView />
        <PointSystemView />
        <AlignerView />
        <PointAlignerView />
        <ValuePropositionView />
        <FlowView />
        <ExampleView />
        <OwnerView />
        <Footer />
      </MainContent>
    </div>
  );
}

export default App;
